export default __webpack_public_path__ + "static/media/payment-icon-3.3e62f7b3.png";